// src/lib/api.js
import axios from 'axios';

/**
 * Base URL priority:
 *  1) Build-time env (Vite): VITE_API_BASE or VITE_API_URL
 *  2) Optional runtime override via window.__ENV.API_BASE (if you ever serve /env.js)
 *  3) Fallback to '/api' (useful only when you proxy in dev)
 */
const buildBase =
  (import.meta?.env?.VITE_API_BASE || import.meta?.env?.VITE_API_URL || '').trim();

const runtimeBase =
  typeof window !== 'undefined' && window.__ENV?.API_BASE
    ? String(window.__ENV.API_BASE).trim()
    : '';

const baseURL = buildBase || runtimeBase || '/api';

const api = axios.create({
  baseURL,
  withCredentials: true, // send/receive the sid cookie
  timeout: 15000,
});

// Optional helper if you also need the socket base in the UI:
export const WS_BASE =
  (import.meta?.env?.VITE_WS_URL || runtimeBase || buildBase || '').trim();

export default api;


